(function () {
  'use strict';

  var API_URL = (window.SLOWDECO_CHAT_URL || '').replace(/\/$/, '');
  var POLL_INTERVAL = 2500;
  var BRIDGE_TYPING_TIMEOUT = 18000; // máx 18s esperando respuesta real

  var GREEN = '#556b57';
  var GREEN_DARK = '#445646';
  var GREEN_SOFT = '#eef2ec';
  var BG = '#f6f3ee';
  var PANEL = '#fffdf9';
  var TEXT = '#282828';
  var TEXT_SOFT = '#6f6a63';
  var BORDER = '#e7e1d8';
  var SHADOW = '0 10px 34px rgba(40,40,40,0.12)';
  var FONT = '"DM Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

  var sessionId = null;
  var pollTimer = null;
  var bridgeTypingTimer = null;  // FIX: timer para limpiar typing de bridge
  var lastTs = '';
  var isOpen = false;
  var isSending = false;
  var sendSafetyTimer = null;    // FIX: reseteo de seguridad de isSending

  // ── DETECCIÓN DE CLIENTE CONOCIDO ─────────────────────────────────────────
  function getKnownCustomer() {
    if (window.slowdecoCustomer && window.slowdecoCustomer.email) {
      return window.slowdecoCustomer;
    }
    try {
      var stored = localStorage.getItem('slowdeco_customer');
      if (stored) {
        var parsed = JSON.parse(stored);
        if (parsed && parsed.email) return parsed;
      }
    } catch (e) {}
    return null;
  }

  function saveCustomerLocal(data) {
    try {
      localStorage.setItem('slowdeco_customer', JSON.stringify({
        email: data.email,
        name: data.name,
        phone: data.phone || ''
      }));
    } catch (e) {}
  }

  function loadFont() {
    if (document.getElementById('sd-font')) return;
    var link = document.createElement('link');
    link.id = 'sd-font';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap';
    document.head.appendChild(link);
  }

  function injectStyles() {
    var s = document.createElement('style');
    s.textContent = [
      '#sd-btn{position:fixed !important;bottom:20px !important;left:20px !important;z-index:2147483647 !important;width:58px;height:58px;border-radius:50%;background:' + GREEN + ';border:none;cursor:pointer;box-shadow:0 6px 24px rgba(85,107,87,0.28);display:flex !important;align-items:center;justify-content:center;padding:0;transition:transform .2s ease, box-shadow .2s ease}',
      '#sd-btn:hover{transform:scale(1.05);box-shadow:0 8px 28px rgba(85,107,87,0.34)}',
      '#sd-btn svg{width:25px;height:25px;fill:white;display:block}',
      '#sd-badge{position:absolute;top:-3px;right:-3px;width:18px;height:18px;border-radius:50%;background:#c96f4a;color:white;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;border:2px solid white;pointer-events:none}',

      '#sd-win{position:fixed !important;bottom:88px !important;left:20px !important;z-index:2147483646 !important;width:340px;max-height:calc(100vh - 112px) !important;height:auto;border-radius:20px;overflow:hidden;box-shadow:' + SHADOW + ';display:flex !important;flex-direction:column;font-family:' + FONT + ';font-size:14px;color:' + TEXT + ';background:' + PANEL + ';opacity:0;pointer-events:none;transform:translateY(12px);transition:opacity .24s ease,transform .24s ease}',
      '#sd-win.open{opacity:1 !important;pointer-events:all !important;transform:translateY(0) !important}',

      '#sd-hdr{background:' + PANEL + ';padding:16px 16px 14px;display:flex;align-items:center;gap:10px;flex-shrink:0 !important;border-bottom:1px solid ' + BORDER + '}',
      '#sd-av{width:36px;height:36px;border-radius:50%;background:' + GREEN_SOFT + ';display:flex;align-items:center;justify-content:center;flex-shrink:0}',
      '#sd-av svg{width:18px;height:18px;fill:' + GREEN + '}',
      '#sd-hi{flex:1;min-width:0}',
      '#sd-hn{color:' + TEXT + ';font-size:14px;font-weight:600;letter-spacing:.01em;font-family:' + FONT + '}',
      '#sd-hs{color:' + TEXT_SOFT + ';font-size:11px;display:flex;align-items:center;gap:6px;margin-top:3px;font-family:' + FONT + '}',
      '#sd-dot{width:6px;height:6px;border-radius:50%;background:' + GREEN + ';flex-shrink:0;opacity:.8}',
      '#sd-x{background:none;border:none;cursor:pointer;color:' + TEXT_SOFT + ';font-size:20px;line-height:1;padding:4px;flex-shrink:0}',

      '#sd-body{flex:1 1 auto;overflow-y:auto !important;padding:14px 12px;background:' + BG + ';display:flex;flex-direction:column;gap:10px;min-height:90px}',

      '.sdm{display:flex;flex-direction:column;max-width:85%}',
      '.sdm.bot,.sdm.agent{align-self:flex-start}',
      '.sdm.customer{align-self:flex-end}',
      '.sdb{padding:10px 14px;font-size:13px;line-height:1.55;word-break:break-word;font-family:' + FONT + ';letter-spacing:.01em}',
      '.sdm.bot .sdb,.sdm.agent .sdb{background:' + PANEL + ';color:' + TEXT + ';border-radius:8px 16px 16px 16px;border:1px solid ' + BORDER + ';box-shadow:0 1px 0 rgba(0,0,0,.02)}',
      '.sdm.customer .sdb{background:' + GREEN + ';color:white;border-radius:16px 16px 8px 16px}',
      '.sdt{font-size:10px;color:#a49c92;margin-top:4px;padding:0 3px;font-family:' + FONT + '}',
      '.sdm.customer .sdt{text-align:right}',
      '.sdb a{color:' + GREEN + ';text-decoration:underline}',
      '.sdm.customer .sdb a{color:rgba(255,255,255,0.9)}',

      '#sd-typ{align-self:flex-start;background:' + PANEL + ';border:1px solid ' + BORDER + ';border-radius:8px 16px 16px 16px;padding:10px 12px;display:flex;gap:4px;align-items:center}',
      '.sdd{width:6px;height:6px;border-radius:50%;background:#b3aba1;animation:sdb 1.1s infinite}',
      '.sdd:nth-child(2){animation-delay:.18s}.sdd:nth-child(3){animation-delay:.36s}',
      '@keyframes sdb{0%,60%,100%{transform:translateY(0)}30%{transform:translateY(-5px)}}',

      '#sd-form{padding:16px 14px;background:' + PANEL + ';border-top:1px solid ' + BORDER + ';flex-shrink:0}',
      '#sd-form p{font-size:12px;color:' + TEXT_SOFT + ';margin:0 0 12px;line-height:1.55;font-family:' + FONT + '}',
      '#sd-form input{width:100%;padding:11px 12px;font-size:13px;border:1px solid ' + BORDER + ';border-radius:10px;outline:none;margin-bottom:9px;box-sizing:border-box;font-family:' + FONT + ';background:#fcfaf7;color:' + TEXT + '}',
      '#sd-form input::placeholder{color:#a8a096}',
      '#sd-form input:focus{border-color:' + GREEN + ';background:white}',
      '#sd-form input.err{border-color:#c96f4a;background:#fff8f5}',
      '#sd-go{width:100%;padding:11px;background:' + GREEN + ';color:white;border:none;border-radius:10px;font-size:13px;font-weight:600;cursor:pointer;font-family:' + FONT + ';letter-spacing:.01em}',
      '#sd-go:hover{background:' + GREEN_DARK + '}',

      '#sd-foot{background:' + PANEL + ';border-top:1px solid ' + BORDER + ';padding:10px 12px;display:flex;align-items:center;gap:8px;flex-shrink:0}',
      '#sd-inp{flex:1;border:1px solid ' + BORDER + ';border-radius:22px;padding:10px 14px;font-size:13px;background:#fcfaf7;outline:none;font-family:' + FONT + ';color:' + TEXT + '}',
      '#sd-inp::placeholder{color:#a8a096}',
      '#sd-inp:focus{border-color:' + GREEN + ';background:white}',
      '#sd-send{width:36px;height:36px;border-radius:50%;background:' + GREEN + ';border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0}',
      '#sd-send:hover{background:' + GREEN_DARK + '}',
      '#sd-send:disabled{background:#c9c4bc;cursor:default}',
      '#sd-send svg{width:15px;height:15px;fill:white;display:block}',
      '#sd-pw{text-align:center;font-size:10px;color:#b6aea3;padding:6px 0 5px;background:' + PANEL + ';flex-shrink:0;font-family:' + FONT + '}',

      '#sd-gr{position:fixed !important;bottom:88px !important;left:86px !important;z-index:2147483645 !important;background:' + PANEL + ';border:1px solid ' + BORDER + ';border-radius:14px 14px 14px 4px;padding:11px 14px;font-size:13px;color:' + TEXT + ';max-width:210px;line-height:1.45;font-family:' + FONT + ';box-shadow:0 8px 22px rgba(40,40,40,.08)}',

      '@media(max-width:520px){#sd-win{width:calc(100vw - 16px) !important;left:8px !important;bottom:78px !important;max-height:calc(100vh - 100px) !important}#sd-btn{bottom:14px !important;left:14px !important}#sd-gr{display:none !important}}'
    ].join('');
    document.head.appendChild(s);
  }

  // ── MARKDOWN RENDERER ─────────────────────────────────────────────────────
  function renderMarkdown(text) {
    var safe = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
    safe = safe.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    safe = safe.replace(/\*([^*\n]+?)\*/g, '<em>$1</em>');
    safe = safe.replace(/(https?:\/\/[^\s<&"]+)/g,
      '<a href="$1" target="_blank" rel="noopener">$1</a>');
    safe = safe.replace(/(?<![="\/a-z])(slowdeco\.es\/[^\s<&"]+)/g,
      '<a href="https://$1" target="_blank" rel="noopener">https://$1</a>');
    safe = safe.replace(/\n/g, '<br>');
    return safe;
  }

  function buildWidget() {
    var gr = document.createElement('div');
    gr.id = 'sd-gr';
    gr.textContent = '\u00bfTe ayudamos a elegir?';
    document.body.appendChild(gr);

    var btn = document.createElement('button');
    btn.id = 'sd-btn';
    btn.setAttribute('aria-label', 'Abrir chat Slowdeco');
    btn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/></svg>';
    document.body.appendChild(btn);

    var win = document.createElement('div');
    win.id = 'sd-win';
    win.setAttribute('role', 'dialog');
    win.innerHTML = [
      '<div id="sd-hdr">',
        '<div id="sd-av"><svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg></div>',
        '<div id="sd-hi"><div id="sd-hn">Slowdeco</div><div id="sd-hs"><div id="sd-dot"></div>Asesoramiento y atenci\u00f3n al cliente</div></div>',
        '<button id="sd-x" aria-label="Cerrar">\u00d7</button>',
      '</div>',
      '<div id="sd-body"></div>',
      '<div id="sd-form">',
        '<p>D\u00e9janos tus datos y te ayudaremos a encontrar la pieza que mejor encaje contigo y con tu casa.</p>',
        '<input id="sd-name" type="text" placeholder="Nombre *" autocomplete="name" />',
        '<input id="sd-email" type="email" placeholder="Email *" autocomplete="email" />',
        '<input id="sd-phone" type="tel" placeholder="Tel\u00e9fono (opcional)" autocomplete="tel" />',
        '<button id="sd-go" type="button">Continuar</button>',
      '</div>',
      '<div id="sd-foot" style="display:none">',
        '<input id="sd-inp" type="text" placeholder="Escribe tu mensaje..." maxlength="500" />',
        '<button id="sd-send" type="button" aria-label="Enviar"><svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg></button>',
      '</div>',
      '<div id="sd-pw">Slowdeco \u00b7 Estamos aqu\u00ed para ayudarte</div>'
    ].join('');
    document.body.appendChild(win);

    btn.addEventListener('click', function () { isOpen ? closeChat() : openChat(); });
    document.getElementById('sd-x').addEventListener('click', closeChat);
    document.getElementById('sd-go').addEventListener('click', handleIdentify);
    document.getElementById('sd-send').addEventListener('click', sendMessage);
    document.getElementById('sd-inp').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
    });
    ['sd-name', 'sd-email', 'sd-phone'].forEach(function (id, i, arr) {
      document.getElementById(id).addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          i < arr.length - 1 ? document.getElementById(arr[i + 1]).focus() : handleIdentify();
        }
      });
    });
    setTimeout(function () {
      if (!isOpen && !document.getElementById('sd-badge')) {
        var badge = document.createElement('div');
        badge.id = 'sd-badge';
        badge.textContent = '1';
        btn.appendChild(badge);
      }
    }, 8000);

    var known = getKnownCustomer();
    if (known) {
      var nEl = document.getElementById('sd-name');
      var eEl = document.getElementById('sd-email');
      var pEl = document.getElementById('sd-phone');
      if (nEl && known.name) nEl.value = known.name;
      if (eEl && known.email) eEl.value = known.email;
      if (pEl && known.phone) pEl.value = known.phone;
      if (known.email && known.name) {
        startChatWithCustomer(known);
      }
    }
  }

  function startChatWithCustomer(customer) {
    activateChat();
    fetch(API_URL + '/api/chat/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: customer.name,
        email: customer.email,
        phone: customer.phone || ''
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      sessionId = d.session_id;
      try { sessionStorage.setItem('sd_sid', sessionId); } catch (e) {}
      var firstName = (customer.name || '').split(' ')[0];
      var greeting = d.greeting || ('Hola ' + firstName + '! \u00bfEn qu\u00e9 te puedo ayudar hoy?');
      showMsg(greeting, 'bot');
      startPolling();
    })
    .catch(function () {
      // FIX: si falla la API, asignar sessionId temporal para no bloquear el envío
      sessionId = 'offline_' + Date.now();
      var firstName = (customer.name || '').split(' ')[0];
      showMsg('Hola ' + firstName + '! \u00bfEn qu\u00e9 te puedo ayudar? (modo offline)', 'bot');
    });
  }

  function validate() {
    var name = (document.getElementById('sd-name').value || '').trim();
    var email = (document.getElementById('sd-email').value || '').trim();
    var phone = (document.getElementById('sd-phone').value || '').trim();
    var ok = true;
    ['sd-name', 'sd-email'].forEach(function (id) {
      document.getElementById(id).classList.remove('err');
    });
    if (!name) { document.getElementById('sd-name').classList.add('err'); ok = false; }
    if (!email || email.indexOf('@') < 0) { document.getElementById('sd-email').classList.add('err'); ok = false; }
    return ok ? { name: name, email: email, phone: phone } : null;
  }

  function handleIdentify() {
    var vals = validate();
    if (!vals) return;
    saveCustomerLocal(vals);
    activateChat();
    fetch(API_URL + '/api/chat/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: vals.name, email: vals.email, phone: vals.phone })
    })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      sessionId = d.session_id;
      try { sessionStorage.setItem('sd_sid', sessionId); } catch (e) {}
      showMsg(d.greeting || 'Hola, bienvenida a Slowdeco. \u00bfEn qu\u00e9 podemos ayudarte?', 'bot');
      startPolling();
    })
    .catch(function () {
      // FIX: no dejar sessionId null — mostrar error claro y permitir reintentar
      showMsg('Hay un problema de conexión. Puedes escribirnos a info@sluwdeco.com o intentarlo de nuevo en un momento.', 'bot');
      // FIX: reactivar el formulario para que puedan reintentar
      setTimeout(function () {
        var form = document.getElementById('sd-form');
        var foot = document.getElementById('sd-foot');
        if (form) form.style.display = 'block';
        if (foot) foot.style.display = 'none';
        sessionId = null;
      }, 500);
    });
  }

  function activateChat() {
    document.getElementById('sd-form').style.display = 'none';
    document.getElementById('sd-foot').style.display = 'flex';
    var gr = document.getElementById('sd-gr');
    if (gr) gr.style.display = 'none';
    var badge = document.getElementById('sd-badge');
    if (badge) badge.remove();
    setTimeout(function () { var inp = document.getElementById('sd-inp'); if (inp) inp.focus(); }, 120);
  }

  function showMsg(text, role) {
    if (!text || text === '...') return;
    var body = document.getElementById('sd-body');
    var now = new Date();
    var time = pad(now.getHours()) + ':' + pad(now.getMinutes());
    var w = document.createElement('div'); w.className = 'sdm ' + role;
    var b = document.createElement('div'); b.className = 'sdb';
    b.innerHTML = renderMarkdown(text);
    var t = document.createElement('div'); t.className = 'sdt'; t.textContent = time;
    w.appendChild(b); w.appendChild(t);
    body.appendChild(w);
    body.scrollTop = body.scrollHeight;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function showTyping() {
    var body = document.getElementById('sd-body');
    if (document.getElementById('sd-typ')) return;
    var t = document.createElement('div');
    t.id = 'sd-typ';
    t.innerHTML = '<div class="sdd"></div><div class="sdd"></div><div class="sdd"></div>';
    body.appendChild(t);
    body.scrollTop = body.scrollHeight;
  }

  function hideTyping() {
    var t = document.getElementById('sd-typ');
    if (t) t.remove();
    // FIX: limpiar también el timer de bridge si existe
    if (bridgeTypingTimer) {
      clearTimeout(bridgeTypingTimer);
      bridgeTypingTimer = null;
    }
  }

  // FIX: resetear isSending de forma segura
  function resetSending() {
    isSending = false;
    if (sendSafetyTimer) { clearTimeout(sendSafetyTimer); sendSafetyTimer = null; }
    var s = document.getElementById('sd-send'); if (s) s.disabled = false;
    var i = document.getElementById('sd-inp'); if (i) i.focus();
  }

  function sendMessage() {
    if (isSending) return;

    var inp = document.getElementById('sd-inp');
    var msg = (inp.value || '').trim();
    if (!msg) return;

    // FIX: si no hay sessionId, mostrar error claro en vez de silencio
    if (!sessionId) {
      showMsg('La conexión no está lista. Por favor espera un momento e inténtalo de nuevo.', 'bot');
      return;
    }

    inp.value = '';
    isSending = true;
    var sb = document.getElementById('sd-send');
    if (sb) sb.disabled = true;

    // FIX: timer de seguridad — resetear isSending tras 30s en cualquier caso
    sendSafetyTimer = setTimeout(function () {
      if (isSending) {
        resetSending();
        hideTyping();
        showMsg('La respuesta está tardando más de lo esperado. Puedes seguir escribiendo.', 'bot');
      }
    }, 30000);

    showMsg(msg, 'customer');
    showTyping();

    fetch(API_URL + '/api/chat/message', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId, message: msg })
    })
    .then(function (r) {
      // FIX: verificar que la respuesta es JSON antes de parsear
      var contentType = r.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) {
        throw new Error('Respuesta no válida del servidor (HTTP ' + r.status + ')');
      }
      return r.json();
    })
    .then(function (d) {
      if (d.takeover) {
        hideTyping();
        showMsg('Enseguida te atender\u00e1 una persona del equipo.', 'bot');
        resetSending();
      } else if (d.bridge) {
        // Respuesta puente — mostrar y esperar la real por poll
        var key = (d.response || '').slice(0, 40);
        shownMessages['shown|' + key] = true;
        showMsg(d.response, 'bot');
        // FIX: typing con timeout máximo — si el poll no responde en 18s, limpiar
        setTimeout(function () { showTyping(); }, 400);
        bridgeTypingTimer = setTimeout(function () {
          hideTyping();
          showMsg('Estamos preparando tu respuesta. Si tarda más, escríbenos a info@sluwdeco.com.', 'bot');
        }, BRIDGE_TYPING_TIMEOUT);
        resetSending(); // FIX: liberar el botón aunque haya bridge
      } else if (d.response) {
        hideTyping();
        var key = (d.response || '').slice(0, 40);
        shownMessages['shown|' + key] = true;
        showMsg(d.response, 'bot');
        resetSending();
      } else {
        // FIX: respuesta vacía — limpiar estado
        hideTyping();
        resetSending();
      }
    })
    .catch(function (err) {
      hideTyping();
      // FIX: distinguir error de red vs error de servidor
      var isNetworkError = !navigator.onLine || err.message === 'Failed to fetch';
      if (isNetworkError) {
        showMsg('Sin conexión. Comprueba tu conexión a internet e inténtalo de nuevo.', 'bot');
      } else {
        showMsg('Ha habido un problema. Puedes escribirnos directamente a info@sluwdeco.com.', 'bot');
      }
      resetSending();
    });
  }

  var shownMessages = {};

  function markShown(content) {
    var key = (content || '').slice(0, 40);
    shownMessages['shown|' + key] = true;
  }

  function isShown(content, ts) {
    var keyContent = 'shown|' + (content || '').slice(0, 40);
    var keyTs = (ts || '') + '|' + (content || '').slice(0, 40);
    return shownMessages[keyContent] || shownMessages[keyTs];
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(function () {
      if (!sessionId || !isOpen) return;
      fetch(API_URL + '/api/chat/poll?session_id=' + sessionId + '&since=' + encodeURIComponent(lastTs))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.messages && d.messages.length > 0) {
          d.messages.forEach(function (m) {
            if (m.ts && m.ts > lastTs) lastTs = m.ts;
          });
          d.messages.forEach(function (m) {
            if (m.role !== 'bot' && m.role !== 'agent') return;
            if (!m.content || m.content === '...') return;
            if (isShown(m.content, m.ts)) return;
            var tsKey = (m.ts || '') + '|' + (m.content || '').slice(0, 40);
            shownMessages[tsKey] = true;
            markShown(m.content);
            hideTyping(); // limpia typing del bridge también
            showMsg(m.content, m.role);
          });
        }
      })
      .catch(function () {});
    }, POLL_INTERVAL);
  }

  function openChat() {
    isOpen = true;
    document.getElementById('sd-win').classList.add('open');
    var gr = document.getElementById('sd-gr'); if (gr) gr.style.display = 'none';
    var badge = document.getElementById('sd-badge'); if (badge) badge.remove();
    if (sessionId) startPolling();
    var form = document.getElementById('sd-form');
    if (form && form.style.display !== 'none') {
      setTimeout(function () { var n = document.getElementById('sd-name'); if (n) n.focus(); }, 100);
    }
  }

  function closeChat() {
    isOpen = false;
    document.getElementById('sd-win').classList.remove('open');
    if (pollTimer) { clearInterval(pollTimer); pollTimer = null; }
    // FIX: limpiar también el timer de bridge al cerrar
    if (bridgeTypingTimer) { clearTimeout(bridgeTypingTimer); bridgeTypingTimer = null; }
  }

  function init() {
    if (!API_URL) { console.warn('Slowdeco Chat: falta window.SLOWDECO_CHAT_URL'); return; }
    loadFont();
    injectStyles();
    buildWidget();
    try { var saved = sessionStorage.getItem('sd_sid'); if (saved) sessionId = saved; } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

